if ( objects.is_aventures ) {
    
}